import { render, staticRenderFns } from "./tree-item.vue?vue&type=template&id=95e20740&"
import script from "./tree-item.component.ts?vue&type=script&lang=ts&"
export * from "./tree-item.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\opusb-web-myactio\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('95e20740')) {
      api.createRecord('95e20740', component.options)
    } else {
      api.reload('95e20740', component.options)
    }
    module.hot.accept("./tree-item.vue?vue&type=template&id=95e20740&", function () {
      api.rerender('95e20740', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/core/application-dictionary/components/TreeView/tree-item.vue"
export default component.exports